import BigNumber from 'bignumber.js'
import Identicon from 'identicon.js'
import numeral from 'numeral'
import { useMemo } from 'react'

import MyRewards from '@/assets/myrewards.png'
import WanPos from '@/assets/wanPos.png'
import { useLocalStorage } from '@/context/localstorage-context'
import { fromWei1 } from '@/utils'
import {
  useStoremanInfo,
  useQueryTokenPrice,
  useQueryStoremanConf,
} from '@/utils/queries'

import BridgeStatisticsModule from './bridge-statistics'
import {
  BridgeStatistics,
  BridgeTvlInUsd,
  BridgeTvlInUsdMedia,
  Con,
  Container,
  Data,
  Data1,
  Gap,
  Img,
  LineStyle,
  StatisticsAvg,
  StatisticsTitle,
  StatisticsTvl,
} from './Bridge.module'
import { useStoremanDelegatorInfo } from './storeman-data'
import StoremanLists from './storeman-lists'

export default function Bridge() {
  const storemanInfo = useStoremanInfo()
  const { theme } = useLocalStorage()
  const storemanDelegatorInfo = useStoremanDelegatorInfo()
  const { data: tokensPrice, isLoading: tokensPriceLoading } =
    useQueryTokenPrice()
  const storemanConf = useQueryStoremanConf()
  const isdark = useMemo(() => theme === 'dark', [theme])

  const storemanList = useMemo(() => {
    if (storemanInfo && storemanInfo.length > 0) {
      storemanInfo.forEach((i: any) => {
        i.myDeposit = '0'
        i.myIncentive = '0'
        i.quota = '0'
        storemanDelegatorInfo.forEach((j: any) => {
          if (i.wkAddr.toLowerCase() === j.wkAddr.toLowerCase()) {
            i.myDeposit = j.deposit.toString()
            i.myIncentive = j.incentive.toString()
          }
        })
        if (storemanConf) {
          const quota = new BigNumber(fromWei1(i.deposit))
            .plus(fromWei1(i.partnerDeposit || '0'))
            .multipliedBy(storemanConf.delegationMulti || '1')
            .minus(fromWei1(i.delegateDeposit || '0'))
            .toString(10)
          i.quota = numeral(quota).format('0,0')
        }
      })
      return storemanInfo
    } else {
      return []
    }
  }, [storemanDelegatorInfo, storemanInfo, storemanConf])

  const storemanListMydelegate = useMemo(() => {
    if (storemanInfo && storemanInfo.length > 0) {
      const ret: any[] = []

      storemanDelegatorInfo.forEach((i: any) => {
        const tmp = storemanInfo.find(
          (j: any) => i.wkAddr.toLowerCase() === j.wkAddr.toLowerCase(),
        )
        if (!tmp) {
          i.name = i.wkAddr
          i.storeman = ''
          i.activity = '0'
          i.delegateFee = '0'
          i.imgdata = `data:image/png;base64,${new Identicon(
            i.wkAddr,
          ).toString()}`
          i.myDeposit = i.deposit.toString()
          i.myIncentive = i.incentive.toString()
          ret.push(i)
        }
      })
      return ret
    } else {
      return []
    }
  }, [storemanDelegatorInfo, storemanInfo])

  const myAllDelegates = useMemo(() => {
    return storemanDelegatorInfo.reduce(
      (prev: string, i: { deposit: string }) =>
        new BigNumber(prev).plus(i.deposit).toString(),
      0,
    )
  }, [storemanDelegatorInfo])

  const myTotalIncentive = useMemo(() => {
    return storemanDelegatorInfo.reduce(
      (prev: string, i: { incentive: string }) =>
        new BigNumber(prev).plus(i.incentive).toString(),
      0,
    )
  }, [storemanDelegatorInfo])

  const WanPrice = useMemo(() => {
    if (!tokensPriceLoading && tokensPrice) {
      return tokensPrice.wanchain?.usd || '0'
    } else {
      return '0'
    }
  }, [tokensPrice, tokensPriceLoading])

  const myAllDelegatesInUsd = useMemo(() => {
    const tmp = new BigNumber(WanPrice)
      .multipliedBy(myAllDelegates || '0')
      .toString()
    return numeral(tmp).format('0,0')
  }, [WanPrice, myAllDelegates])

  return (
    <Container>
      {/* Total  */}
      <BridgeStatisticsModule />
      <Gap />
      {/* Personal  */}
      {new BigNumber(myAllDelegates).gt('0') && (
        <BridgeStatistics className="bg-white dark:bg-common-1">
          <StatisticsTvl>
            <StatisticsTitle className="text-light-0 dark:text-dark-0">
              My Delegations
              <BridgeTvlInUsd>
                <Data1>{myAllDelegatesInUsd} USD</Data1>
              </BridgeTvlInUsd>
            </StatisticsTitle>
            <Con>
              <Img src={WanPos} alt="WanPos" />
              <Data>
                <div className="text-light-111 dark:text-white">
                  {numeral(myAllDelegates)
                    .format('0,0.00')
                    .replace(/\.?0+$/, '')}{' '}
                  <Data1>WAN</Data1>
                </div>
                <BridgeTvlInUsdMedia>
                  <Data1>{myAllDelegatesInUsd} USD</Data1>
                </BridgeTvlInUsdMedia>
              </Data>
            </Con>
          </StatisticsTvl>
          <LineStyle isdark={isdark} />
          <StatisticsAvg>
            <StatisticsTitle className="text-light-0 dark:text-dark-0">
              My Rewards
            </StatisticsTitle>
            <Con>
              <Img src={MyRewards} alt="Rewards" />
              <Data>
                <div className="text-light-222 dark:text-white">
                  {numeral(myTotalIncentive)
                    .format('0,0.0000')
                    .replace(/\.?0+$/, '')}{' '}
                  <Data1>WAN</Data1>
                </div>
              </Data>
            </Con>
          </StatisticsAvg>
        </BridgeStatistics>
      )}
      <StoremanLists
        storemanList={storemanList}
        withdrawStoreman={storemanListMydelegate}
      />
    </Container>
  )
}
